<script setup lang="ts">
import type { UseCaseArticleChapter } from '@/data/useCases'

// The numbered contents list, grouped by part. One list serves both the sticky rail
// (lg and up) and the dropdown under the progress bar (below lg).
export interface ContentsGroup {
  id: string
  title?: string
  chapters: { chapter: UseCaseArticleChapter; number: number }[]
}

defineProps<{ groups: ContentsGroup[]; activeId: string | null; costNumber: number }>()
const emit = defineEmits<{ navigate: [] }>()

// The number sits inside the link and the row centres both, so they cannot drift apart.
const rowBase = 'flex items-center gap-3 min-h-11 pl-3 -ml-px border-l-2 text-sm transition-colors hover:text-surface-50'
const rowOn = 'border-primary-300 text-surface-50 font-medium'
const rowOff = 'border-transparent text-surface-300'
</script>

<template>
  <div class="space-y-4 border-l border-surface-800">
    <div v-for="group in groups" :key="group.id">
      <p v-if="group.title" class="pl-3 mb-0.5 text-xs uppercase tracking-wide text-surface-400">{{ group.title }}</p>
      <ol>
        <li v-for="item in group.chapters" :key="item.chapter.id">
          <a
            :href="`#${item.chapter.id}`"
            :aria-current="activeId === item.chapter.id ? 'true' : undefined"
            :class="[rowBase, activeId === item.chapter.id ? rowOn : rowOff]"
            @click="emit('navigate')"
          >
            <span class="w-5 shrink-0 text-center font-mono text-primary-300">{{ item.number }}</span>
            <span>{{ item.chapter.short ?? item.chapter.title }}</span>
          </a>
        </li>
      </ol>
    </div>
    <div>
      <p class="pl-3 mb-0.5 text-xs uppercase tracking-wide text-surface-400">The bill</p>
      <a
        href="#article-cost"
        :aria-current="activeId === 'article-cost' ? 'true' : undefined"
        :class="[rowBase, activeId === 'article-cost' ? rowOn : rowOff]"
        @click="emit('navigate')"
      >
        <span class="w-5 shrink-0 text-center font-mono text-primary-300">{{ costNumber }}</span>
        <span>What it cost</span>
      </a>
    </div>
  </div>
</template>
